import React, { useState } from 'react';
import Business from '../../images/certificates/Business.png';
import Clasification from '../../images/certificates/Clasification.png';
import Incorperation from '../../images/certificates/Incorperation.png';
import Procurement from '../../images/certificates/Procurement.png';
import Registration from '../../images/certificates/Registration.png';

const certificates = [
  { src: Business, title: 'Business Registration Certificate' },
  { src: Incorperation, title: 'Certificate of Incorporation' },
  { src: Registration, title: 'Company Registration Certificate' },
  { src: Clasification, title: 'Classification Certificate' },
  { src: Procurement, title: 'Procurement Authority Certificate' },
];

const CertificatesSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const closeModal = () => setActiveIndex(null);

  const goToPrev = () => {
    setActiveIndex((prev) => (prev === 0 ? certificates.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setActiveIndex((prev) => (prev === certificates.length - 1 ? 0 : prev + 1));
  };

  const active = activeIndex !== null ? certificates[activeIndex] : null;

  return (
    <section className="client_logo_section section_space">
      <div className="container">
        <div className="section_space pt-0">
          <div className="heading_block text-center">
            <div className="heading_focus_text mb-0">
              <span className="badge bg-secondary text-white">Official</span>
              Certificates
            </div>
            <h2 className="heading_text mb-0">Certifications & Registrations</h2>
          </div>
        </div>

        <div className="row justify-content-center g-4 mt-4">
          {certificates.map((item, idx) => (
            <div className="col-md-4 col-sm-6" key={idx}>
              <button
                type="button"
                className="card h-100 shadow-sm border-0 text-start p-0 bg-white w-100"
                onClick={() => setActiveIndex(idx)}
                style={{ cursor: 'pointer' }}
              >
                <div className="card-img-top p-2">
                  <img
                    src={item.src}
                    alt={item.title}
                    className="img-fluid w-100"
                    style={{ objectFit: 'contain', maxHeight: '320px' }}
                  />
                </div>
                <div className="card-body text-center">
                  <h3 className="h6 mb-0">{item.title}</h3>
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>

      {active && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.85)' }}
          tabIndex="-1"
          role="dialog"
          onClick={closeModal}
        >
          {/* Previous Button */}
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); goToPrev(); }}
            style={{
              position: 'fixed',
              left: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(255,255,255,0.9)',
              border: 'none',
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              fontSize: '24px',
              cursor: 'pointer',
              zIndex: 1060,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            aria-label="Previous certificate"
          >
            &#8249;
          </button>

          {/* Next Button */}
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); goToNext(); }}
            style={{
              position: 'fixed',
              right: '20px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(255,255,255,0.9)',
              border: 'none',
              borderRadius: '50%',
              width: '50px',
              height: '50px',
              fontSize: '24px',
              cursor: 'pointer',
              zIndex: 1060,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            aria-label="Next certificate"
          >
            &#8250;
          </button>

          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            role="document"
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-content border-0">
              <div className="modal-header">
                <h5 className="modal-title mb-0">{active.title}</h5>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted small">{activeIndex + 1} / {certificates.length}</span>
                  <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
                </div>
              </div>
              <div className="modal-body text-center">
                <img
                  src={active.src}
                  alt={active.title}
                  className="img-fluid"
                  style={{ maxHeight: '80vh', objectFit: 'contain' }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default CertificatesSection;
